import styled from 'styled-components';
import { animated } from 'react-spring';
import { boxShadow, lightGrey2Color } from 'js/config/style';
import Button from 'js/components/common/Button';

export default animated(styled(Button)`
  box-shadow: ${boxShadow};
  display: block;
  margin: calc(-1 * (1.5rem + 1px)) auto 0;

  && {
    && {
      && {
        border: 1px solid ${lightGrey2Color};
      }
    }
  }
`);
